import * as React from 'react';
import styled from 'styled-components';

import { LAYER } from '@doltech/utils/lib/constants';
import { colorsV2 } from '../../figma/colors-v2';

const HEADER_HEIGHT = 64;

const Body = styled.section`
  background-color: ${colorsV2.gray10};
`;

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${LAYER.LAYER1};

  display: grid;
  grid-template-rows: minmax(0, 1fr);

  width: 100%;
  height: ${HEADER_HEIGHT}px;
`;

const Container = styled.main`
  background-color: ${colorsV2.gray10};
  padding-top: ${HEADER_HEIGHT}px;
  height: 100vh;
`;

interface LayoutPageHeaderOnlyProps {
  header?: React.ReactNode;
  children?: React.ReactNode;
}

export const LayoutPageHeaderOnly = (props: LayoutPageHeaderOnlyProps) => {
  const { header, children } = props;

  return (
    <Container className="header-only-page-layout">
      <Header id="header">{header}</Header>
      <Body id="body">{children}</Body>
    </Container>
  );
};
